import "./MagazinesPreview.scss";
import { useParams } from "react-router-dom";
import { useGetMagazineHtmlQuery } from "../../react-query/hooks/queriesHooks/Magazine";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function MagazinePreview() {
  const { magazineId } = useParams();
  const [currentHTML, setCurrentHTML] = useState<string>();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { t } = useTranslation();

  const { data: { data: magazineInfo } = {}, isLoading } =
    useGetMagazineHtmlQuery(Number(magazineId));

  useEffect(() => {
    if (!isLoading && magazineInfo?.embeddedCode) {
      setCurrentHTML(magazineInfo.embeddedCode);

      if (magazineInfo?.title) {
        document.title = `Patro - ${magazineInfo.title}`;
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (currentHTML && iframeRef.current) {
      const iframe = iframeRef.current;
      const iframeDoc =
        iframe.contentDocument || iframe.contentWindow?.document;

      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(`<html>
          <head>
            <title>Patro - ${magazineInfo?.title}</title>
            <link rel="icon" type="image/x-icon" href="https://revuelepatro.be/favicon.ico" />
          </head>
          <body>
            <div>${currentHTML ?? magazineInfo?.embeddedCode}</div>
          </body>
        </html>`);
        iframeDoc.close();
      }
    }
  }, [currentHTML, magazineInfo?.title]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "resize" && iframeRef.current) {
        const newHeight = event.data.height;
        if (newHeight > 200) {
          iframeRef.current.style.height = `${newHeight}px`;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
      document.title = "Patro";
    };
  }, []);

  if (isLoading) return <div className="loading-container" />;

  return (
    <div className="magazine-preview-container hide-scrollbar">
      <iframe
        ref={iframeRef}
        title="Magazine Preview"
        style={{
          width: "100%",
          minHeight: "100vh",
          border: "none",
          overflow: "visible",
        }}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      />
    </div>
  );
}
